import {
  addDisplayName,
  addProps,
  branch,
  flowMax,
  renderNothing,
} from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { sansSerifFontFamily } from 'utils/styles'
import viewsIcon from '../assets/product-tile-views-icon.svg'

const useStyles = createUseStyles({
  views: {
    fontFamily: sansSerifFontFamily,
    fontSize: 10,
    fontWeight: 700,
    lineHeight: '14px',
    color: '#FFFFFF',
    textShadow: '0px 0px 4px rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
  },
  viewsIcon: {
    marginRight: 2,
  },
})

const VIEWS_FORMATTER = new Intl.NumberFormat('en-US')

interface Props {
  count: number
  className?: string
}

export const Views: FC<Props> = flowMax(
  addDisplayName('Views'),
  branch(({ count }) => count === 0, renderNothing()),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ count, className, classes, t }) => (
    <div className={cx(classes.views, className)}>
      <object
        type="image/svg+xml"
        data={viewsIcon}
        className={classes.viewsIcon}
      >
        {t('saves')}
      </object>
      {VIEWS_FORMATTER.format(count)}
    </div>
  )
)
